import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) nav("/");
    else setErr(r.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--rw-bg)] px-6 py-10">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[var(--rw-border)] rounded-[4px] p-8" data-testid="register-form">
        <div className="flex items-center justify-center mb-6">
          <img src="https://customer-assets.emergentagent.com/job_ristwatch-crm/artifacts/304sorwq_logosd.png" className="h-14 w-auto" alt="RistWatch" />
        </div>
        <div className="label-eyebrow mb-2">Create Account</div>
        <h2 className="font-display text-3xl font-bold mb-6">Get started.</h2>
        <div className="space-y-4">
          <div>
            <label className="label-eyebrow block mb-1.5">Name</label>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Jane Doe" data-testid="register-name" />
          </div>
          <div>
            <label className="label-eyebrow block mb-1.5">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" />
          </div>
          <div>
            <label className="label-eyebrow block mb-1.5">Password</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="register-password" />
          </div>
          {err && <div className="text-xs text-red-600 bg-red-50 border border-red-100 px-3 py-2 rounded" data-testid="register-error">{err}</div>}
          <Button type="submit" className="w-full bg-[var(--rw-sidebar)] hover:bg-[var(--rw-sidebar-hover)]" disabled={busy} data-testid="register-submit">
            {busy ? "Creating…" : "Create Account"}
          </Button>
        </div>
        <div className="text-xs text-neutral-500 mt-6 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-[var(--rw-text)] font-semibold underline" data-testid="goto-login">
            Sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
